var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dropdown-menu",style:({ overflow: _vm.overflow }),attrs:{"role":"listbox"}},[(_vm.$slots.header)?_c('div',{staticClass:"dropdown-menu__header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }